module.exports = __webpack_public_path__ + "static/img/2824_phase_function_Paper_Points.261e28c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2824_phase_function_Paper_Points.png
// module id = EbOo
// module chunks = 0